import PropTypes from 'prop-types'
import React from 'react'
import ExcelExportIcon from '@mui/icons-material/FileCopy'

const ExcelExport = ({ className }) => <ExcelExportIcon className={className} />
export default ExcelExport

ExcelExport.propTypes = {
  className: PropTypes.string
}
